import { render, staticRenderFns } from "./create-or-edit-ledger.vue?vue&type=template&id=8f8b653a"
import script from "./create-or-edit-ledger.ts?vue&type=script&lang=js&external"
export * from "./create-or-edit-ledger.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports